





























































import { ActionTypeEnum } from '@empathybroker/tsclient-play/dist/enums/action-type.enum';

import { Route, RouteRecord } from 'vue-router';
import { mapGetters } from 'vuex';

import { CrudForm, LightboxImage, Stepper, UiTextbox } from '../../components';

import { SetContextWithUrlGuard } from '../../guards';

import { CrudFormMixin } from '../../mixins/crud-form.mixin';

import { FeatureNode, Step } from '../../models';

import { ROUTER_CONSTS } from '../../router/router.consts';

import { APP_CONSTS } from '../../store/app/app.consts';

export default {
  name: 'instances-form',
  mixins: [CrudFormMixin],
  components: {
    CrudForm,
    Stepper,
    UiTextbox,
    LightboxImage
  },
  computed: {
    ...mapGetters(APP_CONSTS.moduleName, {
      featuresTree: APP_CONSTS.getters.featuresTree
    }),
    valid: function (): boolean {
      return !!this.item.instanceId;
    },
    detailsTitle: function (): string {
      return (this.item.prettyName || this.item.instanceId);
    },
    formSteps: function (): Step[] {
      const formSteps: Step[] = [
        {
          id: this.dataType,
          label: this.messages.instance,
          route: this.getFormStepRoute(this.dataType)
        }
      ];
      const instancesFeatureNode = SetContextWithUrlGuard.getFeatureNode(this.dataType, this.featuresTree.common);
      instancesFeatureNode.children.forEach((featureNode: FeatureNode) => {
        const formStepRoute = this.getFormStepRoute(featureNode.id);
        formSteps.push({
          id: featureNode.id,
          label: this.$epb.messages.app.features[featureNode.id],
          route: formStepRoute,
          disabled: !formStepRoute
        });
      });
      return formSteps;
    },
    currentFormStepId: function (): string {
      return this.formSteps.find((step: Step) => (step.id === this.$route.meta.featureId)).id;
    }
  },
  data: function () {
    return {
      dataType: ActionTypeEnum.INSTANCE,
      updateMode: this.$route.matched.some((route: RouteRecord) => (route.name === ROUTER_CONSTS.routes.instances.update.root)),
      item: {
        enabled: true,
        instanceId: '',
        logoUrls: {},
        permissions: {
          common: []
        },
        filters: {},
        kpis: [],
        catalog: {
          fields: [],
          resultMappings: {
            id: '',
            name: ''
          }
        },
        tools: {}
      },
      messages: this.$epb.messages.tools.instances
    };
  },
  methods: {
    getFormStepRoute: function (featureId: string): Route {
      const INSTANCES_ROUTES_CONSTS = (this.updateMode ? ROUTER_CONSTS.routes.instances.update : ROUTER_CONSTS.routes.instances.create);
      const formStepRouteName = ((featureId === this.dataType) ? INSTANCES_ROUTES_CONSTS.root : INSTANCES_ROUTES_CONSTS[featureId]);
      if (!!formStepRouteName) {
        return {
          ...this.$route,
          name: formStepRouteName
        };
      }
    }
  }
};
